<div class="EFProductView bg-light">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
    }
    @if (!isLoading) {
        <div class="EFProductView-Inner shadow bg-white">
            <app-ef-product [productData]="productData" [supplierData]="supplierData" [appMode]="appMode" [alwaysShowItineraryMap]="true" [hasBack]="canGoBackToSupplier()" (goBack)="onGoBack()" (showProduct)="onShowProduct($event)"></app-ef-product>
        </div>
    }
</div>